<template>
  <div class="content-tab-area">
    <!-- START content-tab__panel  -->
    <div class="content-tab__panel tab_active">
      <div class="container-fluid">
        <div class="content-tab-wrapper">
          <div class="content-tab-indent">
            <div class="control-panel">
              <div class="control-panel__item">
                <div class="control-parent_item">
                  <a @click="showDownloadModal=true" title="Загрузить отчет" class="control-pdf_link"></a>
                </div>
              </div>
              <div class="control-panel__item">
                <div class="control-parent_item">
                  <a title="Настройка фильтра" class="control-panel__link control-funnel_link"
                     @click="conclusions.showFilterModal=true"> </a>
                </div>
                <div class="control-parent_item">
                  <a title="Группировка" @click="conclusions.showGroupModal=true"
                     class="control-panel__link control-diagram_link"></a>
                </div>
              </div>
              <div class="control-panel__item" v-if="currentUser.ACTIVE_ROLE_CODE === 'expert_org_expert'"
                   style="padding-top: 0px">
                <Multiselect
                    style="float: left"
                    @input="fetchList"
                    label="UF_NAME"
                    :limit="1"
                    track-by="ID"
                    v-model="filter.org"
                    :options="orgList"
                    :multiple="true" placeholder="организация"/>

                <Multiselect
                    style="float: left"
                    @input="fetchList"
                    label="UF_NAME"
                    :limit="1"
                    track-by="ID"
                    v-model="filter.status"
                    :options="directory.status_indent_finalies"
                    :multiple="true" placeholder="Статус заключения"/>
              </div>
              <div v-else class="control-panel__search">
                <select v-model="filter.expert_org" @change="fetchList" class="small_search"
                        style="background: none">
                  <option value="">экспертная организация</option>
                  <option v-for="item in directory.expert_org" :key="item.ID" :value="item.ID">
                    --{{ item.UF_NAME }}
                  </option>
                </select>
                <select v-model="filter.result" @change="fetchList" class="small_search"
                        style="background: none">
                  <option value="">Результат</option>
                  <option v-for="item in directory.conclusion_indent_finalies" :key="item.ID" :value="item.ID">
                    --{{ item.UF_SMALL_NAME }}
                  </option>
                </select>

              </div>
              <div class="control-panel__item" v-if="currentUser.ACTIVE_ROLE_CODE === 'expert_org_assignee'"><a
                  class="link_style-blue" style="padding: 4px 14px" @click="startExpertise">начать экспертизу</a>
              </div>
            </div>

            <InfoFilter
                :items="conclusions"/>
            <!-- control-panel -->
            <TableList
                :items="conclusions"
                :is-loading="isConclusionsLoading"
                :show-check-field="currentUser.ACTIVE_ROLE_CODE === 'expert_org_assignee'"
                :api-service="service"
                :card-link="'LK/conclusions/edit'"
            />

            <ListFilter
                :items="conclusions"
            />
            <div class="modal fade in show" tabindex="-1" v-if="showDownloadModal" role="dialog"
                 aria-labelledby="myModalLabel">
              <div class="modal-dialog modal-middle" role="document">
                <div class="modal-content">
                  <div class="modal-add-document modal-full" v-if="showDownloadModal">
                    <div class="modal-header main-clear">
                      <span class="modal-title">Выбор закючения для печати</span>
                      <a @click="showDownloadModal=false" class="modal-exit stl-FR"></a>
                    </div>
                    <div class="modal-body">
                      <div class="modal_row main-clear">
                        <div class="table-responsive">
                          <table class="filter-table">
                            <tbody>
                            <tr>
                              <td>
                                <select v-model="downloadID"
                                        class="main_input main_select filter-input">
                                  <option :key="o.ID" v-for="o in downloadData"
                                          :value="o.ID">заключение
                                    Рег. № {{ o.UF_NUMBER }} от {{ o.UF_DATE_FINISHED }}
                                  </option>
                                </select>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="modal_row main-clear">
                        <div class="link_style-blue modal-full_wid" v-if="downloadID"
                             @click="downloadReport">
                          Загрузить
                        </div>
                        <div class="link_style-white modal-full_wid"
                             @click="showDownloadModal = false">отмена
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- table-responsive -->
          </div>
          <!-- content-tab-indent -->
        </div>
        <!-- content-tab-wrapper -->
      </div>
      <!-- container-fluid -->
    </div>
    <!-- END content-tab__panel  -->
  </div>
  <!-- content-tab__panel -->
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment";
import {ru} from "vuejs-datepicker/dist/locale";
import Vue from "vue";
import {API_URL} from "@/common/config";
import TableList from "@/components/cabinet/partial/TableList";
import ListFilter from "@/components/cabinet/partial/ListFilter";
import {ConclusionService, TZService} from "@/common/api.service";
import InfoFilter from "@/components/cabinet/partial/InfoFilter";
import Multiselect from "vue-multiselect";

export default {
  name: "ConclusionList",
  components: {InfoFilter, ListFilter, TableList, Multiselect},
  data() {
    return {
      service: ConclusionService,
      ru: ru,
      showDownloadModal: false,
      downloadID: 0,
      downloadData: [],
      filter: {
        expert_org: "",
        result: "",
        org: [],
        status: ""
      },
      applyFilters: [],
      applyGroups: [],
      orgList: [],
      toasterErrors: []
    };
  },
  async mounted() {
    await this.$store.dispatch('fetchDirectories', [
      "expert_org",
      "conclusion_indent_finalies",
      "status_indent_finalies"
    ]);
    await ConclusionService.getListOrgSPConclusions().then(({data}) => {
      this.orgList = data
    })
    await this.fetchList()
  },
  computed: {
    ...mapGetters([
      "conclusions",
      "isConclusionsLoading",
      "directory",
      "currentUser"
    ]),
    listConfig() {
      const q = {
        page: this.conclusions.currentPage,
        limit: this.conclusions.itemsPerPage,
        filter: "",
        group: [],
        filterStatus: null,
        filterCountry: null,
        filterPeriod: {}
      };
      if (this.conclusions.sortColumn !== "") {
        let sort = {
          column: "",
          order: ""
        };
        sort.column = this.conclusions.sortColumn;
        sort.order = this.conclusions.sortOrder;
        q.sort = sort;
      }
      if (this.filter.expert_org > 0) {
        q.filterExpertOrg = this.filter.expert_org
      }
      if (this.filter.result > 0) {
        q.filterResult = this.filter.result
      }
      if (this.filter.org.length > 0) {
        q.filterOrg = []
        for (let i = 0; i < this.filter.org.length; i++) {
          q.filterOrg.push(this.filter.org[i]['ID'])
        }
      }
      if (this.filter.status.length > 0) {
        q.filterStatus = []
        for (let i = 0; i < this.filter.status.length; i++) {
          q.filterStatus.push(this.filter.status[i]['ID'])
        }
      }
      let filterarr = []
      this.conclusions.filters.forEach(function (filter) {
        filterarr.push({
          FIELD: this.conclusions.settings.filterFields[filter.index].FIELD,
          OPERATION: this.conclusions.settings.filterFields[filter.index].OPERATION[filter.operation].CODE,
          VALUE: filter.value, VALUE2: filter.value2,
          LOGIC: this.conclusions.settings.filterFields[filter.index].LOGIC[filter.logic].CODE,
          RUNTIME: this.conclusions.settings.filterFields[filter.index].RUNTIME,
          CODE_RUNTIME: this.conclusions.settings.filterFields[filter.index].CODE_RUNTIME
        })
      }, this);
      q.filter = ""
      if (filterarr.length) {
        q.filter = Buffer.from(JSON.stringify(filterarr)).toString("base64");
      }
      if (this.conclusions.filters.length > 0) {
        Vue.set(this.conclusions, 'applyFilters', JSON.parse(JSON.stringify(this.conclusions.filters)))
      }

      this.conclusions.groups.forEach(function (group) {
        q.group.push(this.conclusions.settings.groupFields[group.index].FIELD)
      }, this);

      if (this.conclusions.groups.length > 0) {
        Vue.set(this.conclusions, 'applyGroups', JSON.parse(JSON.stringify(this.conclusions.groups)))
      }
      return q;
    },
  },
  filters: {
    dateFormat(date) {
      return moment(date).format("DD.MM.YYYY");
    },
  },
  methods: {
    fetchList() {
      this.$store.dispatch('fetchConclusions', this.listConfig).then(() => {
        document.title = unescape(this.conclusions.META_TITLE);
        this.conclusions.showFilterModal = false
        this.conclusions.showGroupModal = false
        ConclusionService.getListPrintPDF().then(({data}) => {
          this.downloadData = data
        }, this)
      }, this)
    },
    downloadReport() {
      ConclusionService.getLinkConclusionsPDF(this.downloadID).then(({data}) => {
        window.open(API_URL.replace(new RegExp("[\\/]+$"), "") + data.link);
      }, this)
    },
    dateFormat(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    startExpertise() {
      let r = []
      this.conclusions.checkedItems.forEach(function (i, k) {
        if (i) {
          r.push(k)
        }
      }, this)
      if (!r.length) {
        alert("Необходимо выбрать заключения для начала проведения экспертизы!")
        return
      }
      ConclusionService.startExpertise({
        UF_CONCLUSION_ID: r
      }).then(({data}) => {
        if (data.error) {
          data.errorAr.forEach(function (err) {
            this.toasterErrors[this.toasterErrors.length] = this.$toasted.show(
                err.TEXT,
                {
                  theme: "bubble",
                  position: "bottom-right",
                  duration: null,
                  action: [
                    {
                      text: "Закрыть",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    {
                      text: "Закрыть все",
                      onClick: () => {
                        this.toasterErrors.forEach(function (err) {
                          err.goAway(0);
                        });
                      }
                    }
                  ]
                }
            );
          }, this);
        } else {
          this.toasterErrors[this.toasterErrors.length] = this.$toasted.show(
              'Выбранные экспертизы переведены в работу',
              {
                theme: "green",
                position: "bottom-right",
                duration: 3000,
                action: [
                  {
                    text: "Закрыть",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  }
                ]
              }
          );
        }
      }, this)
    },
    editTZ(type, cID) {
      if (type === 'create') {
        TZService.createTZ(cID).then(({data}) => {
          this.$router.push({name: 'LK/conclusions/edit-tz', params: {id: data.ID}});
        })
      }
      if (type === 'edit') {
        this.$router.push({name: 'LK/conclusions/edit-tz', params: {id: cID}});
      }
    }
  }
}
</script>

<style scoped>
.modal_row .vdp-datepicker {
  display: inline-block;
}

.multiselect {
  max-width: 300px;
}

.multiselect__tag {
  background: #3d7aaa !important;
}
</style>